module.exports = __webpack_public_path__ + "static/img/7.f70b71e.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/02/7.png
// module id = +rVG
// module chunks = 2